import { gql, TypedDocumentNode } from '@apollo/client';
import type { Contact } from '../models/Contact';

export const GET_CONTACTS_QUERY: TypedDocumentNode<{ contacts: Contact[] }> = gql`
  query GetContacts {
    contacts(order: { name: ASC }) {
      id,
      name,
      email,
      phone
    }
  }
`;

export const GET_CONTACT_BY_ID_QUERY: TypedDocumentNode<{ contact: Contact }, { id: number }> = gql`
  query GetContactById($id: Int!) {
    contact: contactById(id: $id) {
      id,
      name,
      email,
      phone
    }
  }
`;
